<template>
  <el-dialog width="40%" ref="dialog" :visible.sync="visible" @closed="checkWord = ''">
    <div slot="title">{{ $t('c.dialog.titleSwitchToWhiteList') }}</div>

    <div>
      <p>{{ $t('c.dialog.messageSwitchToWhiteList1') }}</p>
      <p>{{ $t('c.dialog.messageSwitchToWhiteList2') }}</p>
      <input v-model="checkWord" :placeholder="$t('c.dialog.placeholderEnterWord')" />
    </div>

    <v-row slot="footer" justify="between">
      <v-button theme="primary" view="transparent" @click="close">{{ $t('c.dialog.buttonCancel') }}</v-button>
      <v-button
        theme="primary"
        :disabled="!canAddToWhiteList"
        @click="movePlacementsToWhiteList"
      >{{ $t('c.dialog.buttonContinue') }}</v-button>
    </v-row>
  </el-dialog>
</template>

<script>
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import visibleMixin from '@/mixins/visible@deprecated'

export default {
  name: 'VPlacementsDialogSwitch',
  components: { VRow },
  mixins: [visibleMixin],

  props: {
    selection: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      checkWord: ''
    }
  },

  computed: {
    canAddToWhiteList() {
      return this.checkWord === 'WHITELIST'
    }
  },

  methods: {
    movePlacementsToWhiteList() {
      this.close()

      const name = types.BLACKLIST_PLACEMENTS
      const ids = this.selection.map(item => item.id)

      if (ids.length) {
        this.$store
          .dispatch(types.MOVE_BLACKLIST_PLACEMENTS_TO_WHITELIST, { name, ids })
          .then(() => this.$emit('moved'))
      }
    }
  }
}
</script>
